import { COUNTRY_OPTIONS } from "./kit";

export const CATEGORY_OPTIONS = [
  { value: "soziales", label: "Soziales" }, { value: "sport", label: "Sport" }, { value: "kultur", label: "Kultur" },
  { value: "bildung", label: "Bildung" }, { value: "freizeit", label: "Freizeit" },
];

export const categoryLabel = (key) => CATEGORY_OPTIONS.find((c) => c.value === key)?.label || key || "–";

export const activityFields = (a = {}) => [
  { name: "title", label: "Titel", required: true, default: a.title_de },
  { name: "category_key", label: "Kategorie", type: "select", required: true, options: CATEGORY_OPTIONS, default: a.category_key },
  { name: "country", label: "Land", type: "select", required: true, options: COUNTRY_OPTIONS, default: a.country,
    help: "Bestimmt die Zeitzone der Aktivität." },
  { name: "date", label: "Datum", type: "date", required: true, default: a.date_local },
  { name: "start", label: "Beginn", type: "time", required: true, default: a.start },
  { name: "end", label: "Ende", type: "time", required: true, default: a.end },
  { name: "location", label: "Treffpunkt", required: true, default: a.location },
  { name: "capacity", label: "Maximale Teilnehmendenzahl", type: "number", required: true, default: a.capacity ? String(a.capacity) : "12" },
  { name: "description", label: "Beschreibung", type: "textarea", default: a.description_de },
  { name: "cost_note", label: "Kosten", default: a.cost_note, help: "z. B. kostenlos oder CHF 10 pro Person" },
  { name: "host_name", label: "Gastgeber:in", default: a.host_name },
  { name: "requires_confirmation", label: "Teilnahme erst nach Bestätigung", type: "checkbox", default: a.requires_confirmation ?? true },
];

export const activityBody = (v) => ({ ...v, capacity: Number(v.capacity) });

export const ACCESS_VALUES = [{ value: "ja", label: "Ja" }, { value: "nein", label: "Nein" }, { value: "unbekannt", label: "Unbekannt" }];
